import React from 'react';
import cx from 'classnames'
import './ImageStatic.scss';

// IMAGE STATIC: image coming from our repo (static image)
// Components such as Dashboard and InitialView use WEBP images.
// PNG images are used as fallbacks.
export type ImageStaticProps = {
    imagePath: string,
    isImageRwd?: boolean,
    isSimpleImage?: boolean,    
    altText?: string,
    classnames?: string
}

const ImageStatic: React.FC<ImageStaticProps> = ({
    imagePath = '',
    isImageRwd = false,    
    isSimpleImage = false,
    altText = '',
    classnames = '',
}) => {
    const currentClient = (import.meta.env.VITE_CLIENT_NAME || 'audi').toLowerCase();

    const resolveImagePath = (rawPath: string) => {
        const normalizedPath = rawPath.trim().replace(/\\/g, '/');

        if (/^(https?:|data:|blob:|\/)/.test(normalizedPath)) {
            return normalizedPath;
        }

        const marker = '/assets/';
        const markerIndex = normalizedPath.lastIndexOf(marker);

        if (markerIndex >= 0) {
            const assetRelativePath = normalizedPath
                .slice(markerIndex + marker.length)
                .replace(/^\/+/, '');

            return `/assets/${currentClient}/img/${assetRelativePath}`;
        }

        const cleanedRelativePath = normalizedPath.replace(/^(\.\/|\.\.\/)+/, '');
        return `/assets/${currentClient}/img/${cleanedRelativePath}`;
    };

    const resolvedImagePath = imagePath ? resolveImagePath(imagePath) : '';
    const pngImagePath = resolvedImagePath.endsWith('.png')
        ? resolvedImagePath
        : `${resolvedImagePath}.png`;

    if (isSimpleImage) {
        return (
            <img
                className={cx(
                    'b-image-static',
                    isImageRwd ? 'is-image-rwd' : '',
                    classnames,
                )}                
                src={resolvedImagePath}
                alt={altText}
                data-testid={altText}
            />
        )   
    }

    return ( 
        <picture
            className={cx(
                'b-image-static',
                isImageRwd ? 'is-image-rwd' : '',
                classnames,
            )}
        >
           {/* png source */}            
            <source
                srcSet={pngImagePath}
                type="image/png"
            />
           {/* png fallback if browser not supports source */}            
            <img
                src={pngImagePath}
                alt={altText}
                data-testid={altText}
            />
        </picture>
    );
};

export default ImageStatic;